import React from 'react'
import { Row, Card } from 'antd'
import { GlobalHeader, GlobalFooter } from './components'

import AccessibilityStyle from '../../styles/Accessibility.module.css'

const Accessibility = () => {
  return (
    <>
      <GlobalHeader />
      <div className={`${AccessibilityStyle["shared-route-container"]}`}>
        <div className={`${AccessibilityStyle["shared-route-accessibility-container"]}`}>
          <Row justify="center">
            <Card className={`${AccessibilityStyle["accessibility-card"]}`}>
              <Row>
                <h2 className={`${AccessibilityStyle["accessibility-title"]}`}>
                  Website Accessibility
                </h2>
              </Row>
              <hr />
              <span>
                CURE auto insurance believes in making our website accessible for all customers, including individuals
                with disabilities. If you have trouble reading or accessing material on our site, please{' '}
              </span>
              <a
                className={`${AccessibilityStyle["accessibility-link-text"]}`}
                href="https://www.cure.com/contact.aspx"
                rel="noopener noreferrer"
                target="_blank"
              >
                contact us
              </a>
              <span>
                . You may also choose to use our Live Chat or call Customer Service at 800-535-CURE (2873) to connect
                with a representative.
              </span>
            </Card>
          </Row>
        </div>
      </div>
      <GlobalFooter />
    </>
  )
}

Accessibility.propTypes = {}

export default Accessibility
